/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePaymentFeeRequest,
  ErrorMessage,
  PaymentFeeDto,
  PaymentProvider,
  VerifyPinRequest,
  VerifyPinResponse,
} from '../models/index';
import {
    CreatePaymentFeeRequestFromJSON,
    CreatePaymentFeeRequestToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    PaymentFeeDtoFromJSON,
    PaymentFeeDtoToJSON,
    PaymentProviderFromJSON,
    PaymentProviderToJSON,
    VerifyPinRequestFromJSON,
    VerifyPinRequestToJSON,
    VerifyPinResponseFromJSON,
    VerifyPinResponseToJSON,
} from '../models/index';

export interface CreatePaymentFeeOperationRequest {
    createPaymentFeeRequest: CreatePaymentFeeRequest;
}

export interface GetActiveFeeForLocationOrGlobalRequest {
    locationId: number;
    paymentProvider: PaymentProvider;
    paymentMethod: string;
    currency: GetActiveFeeForLocationOrGlobalCurrencyEnum;
}

export interface VerifyGlobalFeePinRequest {
    verifyPinRequest: VerifyPinRequest;
}

/**
 * 
 */
export class PaymentFeeControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for createPaymentFee without sending the request
     */
    async createPaymentFeeRequestOpts(requestParameters: CreatePaymentFeeOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createPaymentFeeRequest'] == null) {
            throw new runtime.RequiredError(
                'createPaymentFeeRequest',
                'Required parameter "createPaymentFeeRequest" was null or undefined when calling createPaymentFee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-fees`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePaymentFeeRequestToJSON(requestParameters['createPaymentFeeRequest']),
        };
    }

    /**
     */
    async createPaymentFeeRaw(requestParameters: CreatePaymentFeeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createPaymentFeeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createPaymentFee(requestParameters: CreatePaymentFeeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPaymentFeeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getActiveFeeForLocationOrGlobal without sending the request
     */
    async getActiveFeeForLocationOrGlobalRequestOpts(requestParameters: GetActiveFeeForLocationOrGlobalRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getActiveFeeForLocationOrGlobal().'
            );
        }

        if (requestParameters['paymentProvider'] == null) {
            throw new runtime.RequiredError(
                'paymentProvider',
                'Required parameter "paymentProvider" was null or undefined when calling getActiveFeeForLocationOrGlobal().'
            );
        }

        if (requestParameters['paymentMethod'] == null) {
            throw new runtime.RequiredError(
                'paymentMethod',
                'Required parameter "paymentMethod" was null or undefined when calling getActiveFeeForLocationOrGlobal().'
            );
        }

        if (requestParameters['currency'] == null) {
            throw new runtime.RequiredError(
                'currency',
                'Required parameter "currency" was null or undefined when calling getActiveFeeForLocationOrGlobal().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['paymentProvider'] != null) {
            queryParameters['paymentProvider'] = requestParameters['paymentProvider'];
        }

        if (requestParameters['paymentMethod'] != null) {
            queryParameters['paymentMethod'] = requestParameters['paymentMethod'];
        }

        if (requestParameters['currency'] != null) {
            queryParameters['currency'] = requestParameters['currency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-fees/active/{locationId}`;
        urlPath = urlPath.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters['locationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getActiveFeeForLocationOrGlobalRaw(requestParameters: GetActiveFeeForLocationOrGlobalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentFeeDto>> {
        const requestOptions = await this.getActiveFeeForLocationOrGlobalRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentFeeDtoFromJSON(jsonValue));
    }

    /**
     */
    async getActiveFeeForLocationOrGlobal(requestParameters: GetActiveFeeForLocationOrGlobalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentFeeDto> {
        const response = await this.getActiveFeeForLocationOrGlobalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentFees without sending the request
     */
    async getPaymentFeesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-fees`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentFeesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<PaymentFeeDto>>> {
        const requestOptions = await this.getPaymentFeesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => new Set(jsonValue.map(PaymentFeeDtoFromJSON)));
    }

    /**
     */
    async getPaymentFees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<PaymentFeeDto>> {
        const response = await this.getPaymentFeesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for verifyGlobalFeePin without sending the request
     */
    async verifyGlobalFeePinRequestOpts(requestParameters: VerifyGlobalFeePinRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['verifyPinRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyPinRequest',
                'Required parameter "verifyPinRequest" was null or undefined when calling verifyGlobalFeePin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-fees/verify-global-fee-pin`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyPinRequestToJSON(requestParameters['verifyPinRequest']),
        };
    }

    /**
     */
    async verifyGlobalFeePinRaw(requestParameters: VerifyGlobalFeePinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyPinResponse>> {
        const requestOptions = await this.verifyGlobalFeePinRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyPinResponseFromJSON(jsonValue));
    }

    /**
     */
    async verifyGlobalFeePin(requestParameters: VerifyGlobalFeePinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyPinResponse> {
        const response = await this.verifyGlobalFeePinRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetActiveFeeForLocationOrGlobalCurrencyEnum = {
    NOK: 'NOK',
    DKK: 'DKK',
    SEK: 'SEK',
    GBP: 'GBP'
} as const;
export type GetActiveFeeForLocationOrGlobalCurrencyEnum = typeof GetActiveFeeForLocationOrGlobalCurrencyEnum[keyof typeof GetActiveFeeForLocationOrGlobalCurrencyEnum];
